import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import api from '../api';

export default function Files() {
  const { projectName } = useParams();
  const navigate = useNavigate();
  const name = decodeURIComponent(projectName);
  const [files, setFiles] = useState([]);
  const [form, setForm] = useState({ name: '', url: '' });
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    api.get(`/portal/files/${encodeURIComponent(name)}`).then(r => setFiles(r.data)).catch(() => {});
  }, [name]);

  async function addFile() {
    if (!form.name || !form.url) return;
    const r = await api.post(`/portal/files/${encodeURIComponent(name)}`, form);
    setFiles(prev => [{ id: r.data.id, ...form, created_at: new Date().toISOString() }, ...prev]);
    setForm({ name: '', url: '' });
    setAdding(false);
  }

  async function deleteFile(id) {
    await api.delete(`/portal/files/${id}`);
    setFiles(prev => prev.filter(f => f.id !== id));
  }

  return (
    <div>
      <Navbar title={name} />
      <div className="container" style={{ maxWidth: 700, margin: '0 auto' }}>
        <button onClick={() => navigate(`/project-hub/${projectName}`)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', fontSize: '0.9rem', marginBottom: 16, padding: 0 }}>
          ← חזרה
        </button>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 className="page-title">קבצים</h2>
          <button className="btn btn-primary" onClick={() => setAdding(true)}>+ הוסף קובץ</button>
        </div>

        {adding && (
          <div style={{ background: 'white', borderRadius: 12, padding: 20, marginBottom: 20, border: '1px solid #e5e7eb', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
            <input placeholder="שם הקובץ" value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
              style={{ width: '100%', marginBottom: 10, padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db' }} />
            <input placeholder="קישור לקובץ (URL)" value={form.url} onChange={e => setForm(p => ({ ...p, url: e.target.value }))}
              style={{ width: '100%', marginBottom: 12, padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', direction: 'ltr' }} />
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-primary" onClick={addFile}>הוסף</button>
              <button className="btn btn-secondary" onClick={() => setAdding(false)}>ביטול</button>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {files.length === 0 && <p style={{ color: '#9ca3af', textAlign: 'center', marginTop: 40 }}>אין קבצים עדיין</p>}
          {files.map(f => (
            <div key={f.id} style={{ background: 'white', borderRadius: 10, padding: '14px 18px', border: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: '1.5rem' }}>📄</span>
                <div>
                  <div style={{ fontWeight: 600, color: '#1f2937' }}>{f.name}</div>
                  <div style={{ fontSize: '0.8rem', color: '#6b7280' }}>{new Date(f.created_at).toLocaleDateString('he-IL')}</div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <a href={f.url} target="_blank" rel="noreferrer" className="btn btn-secondary" style={{ textDecoration: 'none', fontSize: '0.85rem' }}>הורד</a>
                <button onClick={() => deleteFile(f.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#dc2626', fontSize: '1.1rem' }}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
